// Research access — entry-signal lifecycle helpers.
//
// Background: Per the Feb 2026 BE handoff, the `/research` lane is now
// gated by a per-consumer `researchAccess` flag on the consumer
// profile. The flag flips true via one of two paths:
//   1. Sign-up that originated from a `/research` URL — BE auto-grants
//      when `researchAccess: true` is included in the signup payload.
//   2. Admin toggle in the back-office consumer tab.
//
// To detect path (1) the FE drops a session-scoped "entry signal" the
// moment an anonymous visitor lands on /research (just before we
// bounce them to /sign-in). That signal:
//   - lives in sessionStorage (per-tab, auto-clears when the tab is
//     closed — survives the auth redirect dance but won't leak across
//     unrelated sessions on a shared computer);
//   - is consumed exactly once by the signup flow, which then clears
//     it so a subsequent return to /research doesn't keep flagging
//     new accounts as research-granted;
//   - is opportunistically cleared on login too, since by then the
//     consumer either has the flag or doesn't — admin grants are how
//     they'd get it after the fact, not a re-tick of the signal.
//
// IMPORTANT: This is a routing hint only. BE is the source of truth.
// FE never reads its own session signal to decide what to render —
// only what to send in the signup payload.
const KEY = "voya9.research_entry";

export function setResearchEntrySignal() {
  try { window.sessionStorage.setItem(KEY, "1"); } catch { /* private mode */ }
}
export function hasResearchEntrySignal() {
  try { return window.sessionStorage.getItem(KEY) === "1"; } catch { return false; }
}
export function clearResearchEntrySignal() {
  try { window.sessionStorage.removeItem(KEY); } catch { /* private mode */ }
}
